import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledUnreadMark = styled.div<{
  $visible: boolean;
  $size?: "small" | "medium";
}>`
  display: flex;
  width: ${({ $visible, $size }) => {
    if (!$visible) return "0px";
    return $size === "medium" ? "8px" : "6px";
  }};
  height: ${({ $size }) => ($size === "medium" ? "8px" : "6px")};
  background-color: ${theme.colors.red_1};
  border-radius: 12px;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  overflow: hidden;
  transition:
    width 0.3s ease,
    margin-left 0.3s ease,
    opacity 0.3s ease;
`;
